<template>
    <form>
        <div class="row">
            <div class="col-12">
                <h4 class="text-center mb-4">
                    {{$ml.get('Delete_Owner_heading')}} <strong>{{owner.name}}</strong>?
                </h4>
            </div>
        </div>
        <div class="row" v-show="owner.brands_count">
            <div class="col-12">
                <div class="form-group">
                    <label for="newOwnerId" v-html="$ml.with('ownerName', owner.name).get('Move_brand_to_owner')"></label>
                    <select name="newOwnerId" id="newOwnerId"
                            class="form-control mb-5"
                            v-model="newOwnerId">
                        <option v-for="ownerOption in ownersToShow"
                                :value="ownerOption.id"
                                :key="ownerOption.id">
                            {{ownerOption.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row justify-content-center align-items-center" v-if="generalError">
            <div class="col-5 form-group">
                <small class="form-text text-danger">
                    {{$ml.get('general_error_msg')}}
                </small>
            </div>
        </div>
        <div class="row" v-if="loading">
            <div class="col-12 text-center">
                <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-6 text-right">
                <a href="#!" class="btn btn-outline-secondary" @click.prevent="closeOwnersModal">Close</a>
            </div>
            <div class="col-6">
                <button class="btn btn-warning" type="submit" @click.prevent="deleteOwner">
                    {{$ml.get('Delete')}}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: "RemoveOwner",
        props: {
            owner: Object,
            owners: Array
        },
        computed: {
            ownersToShow() {
                // let filteredOwners = [];
                // if (this.owners.length) {
                //     filteredOwners = this.owners.filter(obj => {
                //         return obj.id !== this.owner.id
                //     })
                // }
                return this.owners.filter(obj => {
                    return obj.id !== this.owner.id
                })
            }
        },
        watch: {
            owner: function (newValue, oldValue) {
                this.newOwnerId = this.ownersToShow[0].id
            }
        },
        data() {
            return {
                loading: false,
                generalError: false,
                newOwnerId: ''
            }
        },
        methods: {
            deleteOwner() {
                if (!this.loading) {
                    this.generalError = false;
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.loading = true;
                            let data = {
                                id: this.owner.id,
                                newOwnerId: this.newOwnerId
                            };
                            this.$store.dispatch('deleteOwner', data).then(() => {
                                this.loading = false;
                                this.$emit('closeOwnersModal', true);
                            }).catch(() => {
                                this.generalError = true;
                                this.loading = false;
                            });
                        } else {
                            //set errors
                        }
                    });
                }
            },
            closeOwnersModal() {
                this.$emit('closeOwnersModal');
            }
        }
    }
</script>

<style scoped>

</style>
